/** Objets de transfert échangés entre l'API et le front. */
/** Statut d'une application, tel que rapporté par l'API Cloudron. */
export const APP_STATUSES = ['running', 'stopped', 'installing', 'error', 'unknown'];
//# sourceMappingURL=dto.js.map